import { render, staticRenderFns } from "./ViewImageSlider.vue?vue&type=template&id=a848c7da&scoped=true&"
import script from "./ViewImageSlider.vue?vue&type=script&lang=js&"
export * from "./ViewImageSlider.vue?vue&type=script&lang=js&"
import style0 from "./ViewImageSlider.vue?vue&type=style&index=0&id=a848c7da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a848c7da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
